import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import Input from '../../utils/Input';
import swal from 'sweetalert';
import { roleId } from '../../../constants/app';
import { deleteDevice, fetchDevices, setDevicesFilters, setDevicesPaging } from '../../../action/cassa';
import { setUIvisible } from '../../../action/UImobile';
import { fetchCities, fetchFilials } from '../../../action/handbook';
import ErrorContainer from '../../utils/ErrorContainer';
import Portlet from '../../utils/Portlet';
import HeadMobileActionMenu from '../../utils/HeadMobileActionMenu';
import Loader from '../../utils/Loader';
import DevicesTable from './DevicesTable';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class DevicesList extends Component {
    async componentDidMount() {
        await this.props.fetchFilials(null);
        await this.props.fetchCities();
        this.props.fetchDevices();
    }

    state = {
        currentPage: 0
    }

    setPageLimit = (e) => {
        e.preventDefault();
        const updatedPaging = { start: 0, limit: e.target.value};
        this.setState({ currentPage: 0 });
        this.props.setDevicesPaging(updatedPaging);
        this.props.fetchDevices();
    }

    handlePageClick = data => {
        const { paging } = this.props;
        this.setState({ currentPage: data.selected }, () => {
            let nextStart =  data.selected * paging.limit;
            const updatedPaging = {...paging, start: nextStart};
            this.props.setDevicesPaging(updatedPaging);
            this.props.fetchDevices();
        });
    };

    setFilters = (field) => (data) => {
        const { filters } = this.props;
        let updated = {
            ...filters,
            [field]: data
        }

        if(data.value === null) {
            updated = {
                ...filters,
                [field]: null
            }
        }

        if (field === 'city' && data.value !== null) {
            updated.point = null;
        }

        this.props.setDevicesFilters(updated);
        this.props.fetchDevices();   
    }

    onDelete = (id) => {
        swal({
            title: `Удаление оборудование`,
            text: `Вы действительно хотите удалить оборудование №${id}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                this.props.deleteDevice(id);
            }
        });
    }

    renderAdress(item) {
        return `${item.city.name}, ${item.street}, ${item.house}`;
    }

    onRefresh = () => {
        this.props.fetchDevices();
    }

    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Оборудование</h3>
                    <button className="btn btn-secondary btn-icon">
                        <i onClick={this.onRefresh} className='la la-refresh'/>
                    </button>
                    <div className="kt-subheader__group" id="kt_subheader_search">                       
                    </div>
                </div>
                {
                    window.innerWidth > 1024 && [roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector].includes(this.props.role) && (
                        <div className="kt-subheader__toolbar">
                            <Link to="/cassa/devices/add" className="btn btn-label-brand btn-bold">
                                Добавить оборудование
                            </Link>
                        </div>
                    )
                }
                </div>
            </div>
        );
    }

    renderFiltersBlock(){        
        return(
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginTop: '10px', gap: '10px'}}>
                <div style={{ width: 100 }}>
                    <Input
                        disableGroup={true}
                        value={this.props.filters.id}
                        placeholder="ID"
                        onBlur={(e) =>{
                            if (!e.target.value && !this.props.filters.id) return null;
                            if (e.target.value !== this.props.filters.id) this.setFilters('id')(e.target.value);
                            return null;
                        }}
                        type='number'
                    />
                </div>
                <div style={{ width: 100 }}>
                    <Input
                        disableGroup={true}
                        value={this.props.filters.deviceId}
                        placeholder="deviceID"
                        onBlur={(e) =>{
                            if (!e.target.value && !this.props.filters.deviceId) return null;
                            if (e.target.value !== this.props.filters.deviceId) this.setFilters('deviceId')(e.target.value);
                            return null;
                        }}
                        type='number'
                    />
                </div>
                <div style={{ width: 250 }}>
                    <Select
                    isLoading={this.props.loadingCity}
                    isDisabled={this.props.loadingCity}
                    value={this.props.filters.city}
                    closeMenuOnSelect={true}
                    onChange={this.setFilters('city')}
                    options={[
                        {value: null, label: 'Все города'},
                        ...this.props.cities.sort((a, b) => {
                            if (a.name < b.name) return -1;
                            if (a.name > b.name) return 1;
                            return 0;
                            })
                            .map(item => ({
                            value: item.id,
                            label: item.name
                        }))
                    ]}
                    placeholder="Город"
                    noOptionsMessage={() => 'Нет городов'}
                    />
                </div>
                <div style={{ width: 250 }}>
                    <Select
                    isLoading={this.props.loadingFilials}
                    isDisabled={this.props.loadingFilials}
                    value={this.props.filters.point}
                    closeMenuOnSelect={true}
                    onChange={this.setFilters('point')}
                    options={[
                        {value: null, label: 'Все филиалы'},
                        ...this.props.filials.filter((el) => {
                            if (this.props.filters.city) {
                                if (el.city.id === this.props.filters.city.value) return true;
                                return false;
                            }
                            return true;
                            })
                            .map((el) => ({ value: el.id, label: this.renderAdress(el) }))
                    ]}
                    placeholder="Филиал"
                    noOptionsMessage={() => 'Нет филиалов'}
                    />
                </div>                
        </div>
        );
    }

    chekMarginPagesDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 400)
            return 1;

        if(userDisplayWidth < 550)
            return 2;

        if(userDisplayWidth < 850)
            return 3;

        if(userDisplayWidth < 1250)
            return 5;

        return 8;
    }

    chekPageRangeDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 550)
            return 2;

        if(userDisplayWidth < 850)
            return 3;

        return 5;
    }

    renderPagination() {
        const { count, paging } = this.props;
        const pages = Math.ceil(+count / +paging.limit);

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={this.chekMarginPagesDisplayed()}
                    pageRangeDisplayed={this.chekPageRangeDisplayed()}
                    forcePage={this.state.currentPage}
                    onPageChange={this.handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />

                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={this.setPageLimit} value={paging.limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            
                        </div>
                        {
                            paging.start + paging.limit >= count ? (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+count} из {count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+paging.start + +paging.limit} из {count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    render() {
        if (this.props.loading || this.props.loadingCity) {
            return (
                <div style={styles.loading}><Loader /></div>
            );
        }

        const actionsMobile =[
            { active: true, name: 'Добавить оборудование', icon: 'flaticon2-lock', action: () => this.onAddDevice(), access: [roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector] },
        ].filter(item => (!item.access || item.access.includes(this.props.role)) && item.active );   
        
        return (
            <Fragment>
                {actionsMobile.length > 0 && <HeadMobileActionMenu actions={actionsMobile}/>}
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <div className="kt-portlet__body">
                        <div className="kt-form kt-form--label-right kt-margin-b-10">
                            {this.renderFiltersBlock()}
                        </div>
                    </div>
                <Portlet fit={true}>
                    <ErrorContainer field="devices" style={{ margin: 15 }} hasCloseButton={true}/>
                    <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
                        <DevicesTable items={this.props.list || []} filials={this.props.filials || []} role={this.props.role} onDelete={this.onDelete}/>
                        {
                            this.props.list.length > 0 && this.renderPagination()
                        }
                    </div>
                </Portlet>
            </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    filters: state.cassa.devices.filters,
    loading: state.loaders.devices,
    loadingFilials: state.loaders.filials,
    cities: state.handbook.cities,
    loadingCity: state.loaders.cities,
    paging: state.cassa.devices.paging,
    count: state.cassa.devices.count,
    list: state.cassa.devices.list,
    role: state.user.info.role.id,
    filials: state.handbook.filials,
    UImobile: state.UImobile,
});

const mapDispatchToProps = {
    fetchFilials: (city) => fetchFilials(city, true),
    fetchDevices: () => fetchDevices(),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton),
    setDevicesFilters: (filters) => setDevicesFilters(filters),
    setDevicesPaging: (paging) => setDevicesPaging(paging),
    fetchCities: () => fetchCities(true),
    deleteDevice: (id) => deleteDevice(id),
}

export default connect(mapStateToProps, mapDispatchToProps)(DevicesList);